import { render, staticRenderFns } from "./TheNavBarMobileItem.vue?vue&type=template&id=52484ea8&scoped=true&"
import script from "./TheNavBarMobileItem.vue?vue&type=script&lang=js&"
export * from "./TheNavBarMobileItem.vue?vue&type=script&lang=js&"
import style0 from "./TheNavBarMobileItem.vue?vue&type=style&index=0&id=52484ea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52484ea8",
  null
  
)

export default component.exports